<template>
  <b-container class="py-5 mt-5 custom-container container">
    <b-row align-v="center" align-h="center" class="mt-5 pt-5">
      <b-col
        cols="12"
        class="px-5 text-center justify-center align-content-center"
      >
        <b-img
          fluid
          :src="require('@/assets/images/iap-success.svg')"
          alt="Account Upgrade Success image"
        ></b-img>
      </b-col>
      <b-col
        cols="12"
        class="px-5 text-center justify-center align-content-center"
      >
        <h2 class="mb-5 font-weight-bold">
          Your account has been upgraded to premium.
        </h2>
        <b-button
          :to="{ name: 'file.list-page' }"
          size="lg"
          variant="primary"
          class="h-auto px-5 py-3"
        >
          Go back to Files
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'IAPSuccessPage'
}
</script>

<style lang="scss" scoped>
.success-container {
  text-align: center;
  padding: 3rem;
  width: 50%;

  @media (max-width: 767px) {
    width: 100% !important;
    padding: 2rem;
  }
}
</style>
